export default __webpack_public_path__ + "static/media/1950.74c68ef3.png";